// extracted by mini-css-extract-plugin
export default {"title":"QualificationChapter_title__69-6w","list":"QualificationChapter_list__8YgDm","item":"QualificationChapter_item__lB+wt"};